import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const OpsInbox = lazy(() => import('../components/ops-inbox/OpsInbox'));
const AIChatRoom = lazy(() => import('../components/ai-chat'));
const MarketingAssistant = lazy(() => import('../components/marketing'));
const SupabaseMetrics = lazy(() => import('../components/SupabaseMetrics'));

export const opsRoutes = (
  <>
    <Route path="/ops-inbox" element={<OpsInbox />} />
    <Route path="/ai-chat" element={<AIChatRoom />} />
    <Route path="/marketing" element={<MarketingAssistant />} />
    <Route path="/supabase-metrics" element={<SupabaseMetrics />} />
  </>
);
